import { REQUEST_CONFIG } from "../../config";
import { postAPIData } from "../../services/api/axios";
import { getCookie } from "../dom";

/**
 * Sends SMS messages using the Axios Fascade to access the API endpoint.
 *
 * @param {Array} messages - An array of message objects to be sent.
 * @returns {Promise<Object>} - The response from the API.
 * @throws {Error} - Throws an error if the messages could not be sent.
 */
const handleSendMessages = async (messages) => {
  try {
    const response = await postAPIData(
      "/dispatch/sendsms",
      (data) => {
        console.warn("Messages sent:", data);
      },
      { messages },
      {
        withCredentials: true,
        headers: {
          "X-CSRFToken": getCookie(REQUEST_CONFIG.xsrfCookieName),
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error(
      "Error sending messages:",
      error.response ? error.response.data : error.message
    );
    throw error; // Re-throw the error to handle it outside if needed
  }
};

export default handleSendMessages;
